import { useIntl } from 'react-intl'

export function useInsuranceProductsData() {
  const intl = useIntl()

  return [{
    type: intl.formatMessage({ id: 'dM_bzPH_Aj1XQehsgQyK', defaultMessage: 'International Escapes', description: 'Product category type for international insurance plans on landing page' }),
    title: intl.formatMessage({ id: 'so_d-rOYyAJGZTm49E7t', defaultMessage: 'Comprehensive Trip Protection', description: 'Product title for comprehensive international travel insurance on landing page' }),
    benefits: [
      {
        text: intl.formatMessage({ id: 'W7qdRoLN-zXX8kcZ9089', defaultMessage: 'Refund bookings for you or your ticket holders at anytime if need to cancel due to illness or injury,', description: 'Benefit description for booking refund coverage in comprehensive trip protection' }),
        includingCovid: true,
      },
      {
        text: intl.formatMessage({ id: 'lRAV7vlhlHSmNE32AkXC', defaultMessage: 'Medical assistance and treatment,', description: 'Benefit description for medical assistance in comprehensive trip protection' }),
        includingCovid: true,
      },
      {
        text: intl.formatMessage({ id: 'enlaZZ2-PE9Y4GQTtEib', defaultMessage: 'Money back for emergency expenses, including accommodation, transport and food', description: 'Benefit description for emergency expense coverage in comprehensive trip protection' }),
        includingCovid: false,
      },
      {
        text: intl.formatMessage({ id: 'rn658SjU3ryA2hiFFNd_', defaultMessage: 'Cover for damaged or stolen personal items', description: 'Benefit description for personal items coverage in comprehensive trip protection' }),
        includingCovid: false,
      },
    ],
    complementaryText: intl.formatMessage({ id: 'Zion3n_70_5bUirfLXbz', defaultMessage: 'Not covered: Pre-existing medical conditions.', description: 'Exclusion note for comprehensive trip protection plan' }),
  }, {
    type: intl.formatMessage({ id: 'dM_bzPH_Aj1XQehsgQyK', defaultMessage: 'International Escapes', description: 'Product category type for international insurance plans on landing page' }),
    title: intl.formatMessage({ id: 'iX7EKwSmSuvLxjDA9E7i', defaultMessage: 'Overseas Medical and Evacuation', description: 'Product title for overseas medical and evacuation insurance on landing page' }),
    benefits: [
      {
        text: intl.formatMessage({ id: 'ndmy2gGUROLd9PTDKOvx', defaultMessage: 'Medical assistance and treatment during your trip,', description: 'Benefit description for medical treatment in overseas medical plan' }),
        includingCovid: true,
      },
      {
        text: intl.formatMessage({ id: 'b40sUD6UrLFoQRE-h_6M', defaultMessage: 'Emergency flights and evacuation', description: 'Benefit description for emergency evacuation in overseas medical plan' }),
        includingCovid: false,
      },
      {
        text: intl.formatMessage({ id: 'WR1o70ujs288uTJnMZTq', defaultMessage: 'Money back for emergency expenses, including accommodation, transport and food,', description: 'Benefit description for emergency expense coverage in overseas medical plan' }),
        includingCovid: true,
      },
    ],
    complementaryText: intl.formatMessage({ id: 't8be3Krh8-OMaBrD9y45', defaultMessage: 'Please note: This cover will not allow a refund if you or another person you’re travelling with needs to cancel your trip prior to departure due to illness or injury', description: 'Important notice about cancellation limitations for overseas medical plan' }),
  }, {
    type: intl.formatMessage({ id: '_qutlCQ_LzGYQM56q6gI', defaultMessage: 'Domestic Escapes', description: 'Product category type for domestic insurance plans on landing page' }),
    title: intl.formatMessage({ id: 'RE566NQN3unYuNQ87XVl', defaultMessage: 'Cancellation and Baggage protection', description: 'Product title for domestic cancellation and baggage insurance on landing page' }),
    blurb: intl.formatMessage({ id: 'kCOMiEYCHUVGJUiOn-qa', defaultMessage: 'If any travellers need to cancel or cut short the trip due to the illness or death of yourself or a close family member...', description: 'Description blurb for domestic cancellation and baggage protection plan' }),
    benefits: [
      {
        text: intl.formatMessage({ id: 'lRD5rN-oMse6SNiGl4vm', defaultMessage: 'your Luxury Escapes package costs will be reimbursed.', description: 'Benefit description for cost reimbursement in domestic protection plan' }),
        includingCovid: false,
      },
      {
        text: intl.formatMessage({ id: 'ACcPCSiPuq_hnLb8Xk3W', defaultMessage: 'cover for damaged or stolen personal items.', description: 'Benefit description for personal items coverage in domestic protection plan' }),
        includingCovid: false,
      },
      {
        text: intl.formatMessage({ id: '4RvSPJnGRd8slf3eJg5A', defaultMessage: 'payments are made instantly into your currency and bank account.', description: 'Benefit description for instant payments in domestic protection plan' }),
        includingCovid: false,
      },
    ],
  }]
}
